function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "33. Aircraft");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "_33._Aircraft",
  "data-name": "33. Aircraft"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M46.41,21.21c-6.12-5.13-12-4.21-20-4.21C18.09,8.68,18.59,9,18,9c-7.59,0-7.5-.18-7.88.53S9.81,10,14.46,17H9.54L5.83,11.45C5.41,10.81,5,11,1,11a1,1,0,0,0-1,1.24l2.49,9.94A9,9,0,0,0,11.25,29H15.8l-5.63,8.45A1,1,0,0,0,11,39c7.47,0,7.29.12,7.71-.29L21.41,36H25a3,3,0,0,0,1.8-5.39L28.41,29H43.59A4.41,4.41,0,0,0,46.41,21.21Zm-7.1.08c.37-.38.55-.29,3.23-.29a14.58,14.58,0,0,1,2.85,2H40A1,1,0,0,1,39.31,21.29ZM17.59,11l6,6H16.87l-4-6Zm0,26H12.87l6.67-10c9.37,0,8.17-.12,7.75.29ZM25,34H23.41l1.93-1.93A1,1,0,0,1,25,34Zm18.59-7c-15.11,0-13.3.12-12.88-.29A1,1,0,0,0,30,25c-11.71,0-11.41-.19-11.83.45l-1,1.55H11.25a7,7,0,0,1-6.79-5.3L2.28,13H4.46l3.71,5.55c.43.65.47.45,8.16.45,20.37,0,19.65-.15,22.13.44A3,3,0,0,0,40,25h6A2.42,2.42,0,0,1,43.59,27Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M30,21v1a1,1,0,0,0,2,0V21A1,1,0,0,0,30,21Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M26,21v1a1,1,0,0,0,2,0V21A1,1,0,0,0,26,21Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M22,21v1a1,1,0,0,0,2,0V21A1,1,0,0,0,22,21Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M18,21v1a1,1,0,0,0,2,0V21A1,1,0,0,0,18,21Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M14,21v1a1,1,0,0,0,2,0V21A1,1,0,0,0,14,21Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M10,21v1a1,1,0,0,0,2,0V21A1,1,0,0,0,10,21Z"
}));

var SvgAircraft = function SvgAircraft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAircraft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Aircraft.0009c61a.svg";
export { ForwardRef as ReactComponent };